<template lang="html">
  <footer id="footer">
    <Row type="flex" justify="space-between">
      <Col>
        <div type="flex" justify="start" class="footer-col">
          <h3>HOW IT WORKS</h3>
          <p><router-link :to="{ name: 'Data Aggregation' }">Data Aggregation</router-link></p>
          <p><router-link :to="{ name: 'Asset Valuations' }">Asset Valuations</router-link></p>
          <p><router-link :to="{ name: 'Dynamic Assessments' }">Dynamic Assessments</router-link></p>
        </div>
      </Col>
      <Col>
        <div type="flex" justify="start" class="footer-col">
          <h3>PRODUCT</h3>
          <p><router-link :to="{ name: 'Features' }">Features</router-link></p>
          <p><router-link :to="{ name: 'Pricing' }">Pricing</router-link></p>
          <!-- <p><a :href="loginUrl" target="_blank">Log Into Dashboard</a></p> -->
        </div>
      </Col>
      <Col>
        <div type="flex" justify="start" class="footer-col">
          <h3>LEGAL</h3>
          <p><router-link :to="{ name: 'Terms of Use' }">Terms of Use</router-link></p>
          <p><router-link :to="{ name: 'Privacy Policy' }">Privacy Policy</router-link></p>
        </div>
      </Col>
      <Col>
        <div type="flex" justify="start" class="footer-col">
          <h3>COMPANY</h3>
          <p>Vue Finance, Inc.</p>
          <p>260 1st Ave S Suite 200</p>
          <p>St. Petersburg, Florida 33701</p>
        </div>
      </Col>
      <Col span="24" style="margin-top: 32px">
        <Row type="flex" justify="space-between" align="middle" style="padding: 8px 16px; padding-top: 0; margin-bottom: 16px;">
          <Col class="sub-footer-actions">
            <Row type="flex" align="middle">
              <EmailListSignupForm></EmailListSignupForm>
            </Row>
          </Col>
          <Col class="sub-footer-actions">
            <!-- <ScheduleButton type="ghost" :isMobile="isMobile" title="Contact Us" eventType="introductory-call" style="margin-left: 4px"></ScheduleButton> -->
            <!-- <ScheduleButton type="default" :isMobile="isMobile" title="Schedule Demo" eventType="demo" style="margin-right: 4px"></ScheduleButton> -->
            <GetStartedButton></GetStartedButton>
          </Col>
        </Row>
      </Col>
    </Row>
    <Row type="flex" align="middle" justify="center" style="padding: 16px;">
      <small>Copyright © 2018 Vue Finance, Inc. All rights reserved.</small>
    </Row>
  </footer>
</template>

<script>
import ScheduleButton from './ScheduleButton';
import GetStartedButton from './GetStartedButton';
import EmailListSignupForm from './EmailListSignupForm';

export default {
  props: ['isMobile'],
  components: { ScheduleButton, GetStartedButton, EmailListSignupForm },
  data() {
    return {
      loginUrl: process.env.LOGIN_URL,
    };
  },
};
</script>

<style lang="css" scoped>
#footer {
  border-top: 1px solid #d7dde4;
  padding: 62px 10vw;
  padding-bottom: 8px;
  color: #00000061;
}

.footer-col {
  /* stretched for ipads, stacked for mobile */
  width: 200px;
  min-width: 150px;
  padding: 24px 16px;
} 

.footer-col h1, h2, h3 {
  color: rgba(44, 56, 73, 0.65);
  font-variant: small-caps;
}

.footer-col p {
  color: #8a98a8;
  font-size: 1em;
}

.sub-footer-actions {
  margin-top: 16px;
  margin-bottom: 16px;
  margin-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/VueFooter.vue